export default {
  namespaced: true,
  actions: {
  },
  mutations: {
    account(state, value) {
      state.account = value
    },
    userName(state, value) {
      state.userName = value
    },
    userHeadImg(state, value) {
      state.userHeadImg = value
    },
    userHeadBanner(state, value) {
      state.userHeadBanner = value
    },
    uri(state, value) {
      state.uri = value
    },
    isInstallMeta(state, value) {
      state.isInstallMeta = value
    },
    isConnectWallet(state, value) {
      state.isConnectWallet = value
    },
    currentRouter(state, value) {
      state.currentRouter = value
    },
    signFlag(state, value) {
      state.signFlag = value
    },
    user(state, value) {
      state.account = value.account
      state.userName = value.userName
      state.userHeadImg = value.userHeadImg
      state.userHeadBanner = value.userHeadBanner
      state.isInstallMeta = value.isInstallMeta
      state.isConnectWallet = value.isConnectWallet
      state.currentRouter = value.currentRouter
      state.signFlag = value.signFlag
    },
  },
  state: {
    account: '', //用户钱包地址
    userName: '', //用户姓名
    userHeadImg: '', //用户头像
    userHeadBanner: '', //用户个人中心背景图
    isInstallMeta: '', //0:未安装 1:安装 是否安装MetaMask
    isConnectWallet: '', //0:未连接 1:连接 是否连接钱包
    currentRouter: '', //用户所在当前路由
    signFlag: false, //签名弹窗是否打开
  },
  getters: {
  },
}